import React, { useContext, useMemo, useReducer } from 'react';
import { DEFAULT_WIDGET_TITLE } from 'utils/constants';
import reducer from './reducer';
import { WidgetContextType, WidgetProviderProps } from './types';

const WidgetContext = React.createContext<WidgetContextType | undefined>(
  undefined,
);

export const WidgetProvider: React.FC<WidgetProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    domainId: undefined,
    expectedNumberOfUnits: undefined,
    hasTheme: undefined,
    prId: undefined,
    showLogo: undefined,
    brandingLogo: undefined,
    status: undefined,
    title: DEFAULT_WIDGET_TITLE,
    unitOrder: [],
    units: {},
    variantId: undefined,
    aspectRatioHeight: undefined,
    aspectRatioWidth: undefined,
    imageResizeStrategy: undefined,
    flagUnitFeature: true,
    flaggedUnits: [],
  });

  return (
    <WidgetContext.Provider
      value={useMemo(() => ({ dispatch, state }), [state])}
    >
      {children}
    </WidgetContext.Provider>
  );
};

export function useWidget() {
  const context = useContext(WidgetContext);

  if (context === undefined) {
    throw new Error('useWidget must be used within a WidgetProvider');
  }

  return context;
}

export default WidgetProvider;
